import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage
  })],
  state: {
    OpenID: '',
    token: '',
    user: '',
    door: '',
    defence: '',
    topc: '',
    nooff: {display: 'none'},
    ding: {display: 'block'},
    doorOpen: true,
    doorSuc: false,
    doorErr: false,
    alarmHandle: false, // 是否处理
    alarmid: '',

    //  新子机列表信息
    childObj: {},
    // 场景（房间）信息
    sceneRoom: {},
    appId: '',
    // 子机数据
    subDevice: {},
    // 选择家庭数据
    familyObj: '',
    // 选择房间数据
    roomObj: ''
  },
  mutations: {
    set_openid (state, openid) {
      state.OpenID = openid
    },
    set_token (state, token) {
      state.token = token
    },
    set_user (state, user) {
      state.user = user
    },
    // mqtt
    set_door (state, door) {
      state.door = door
    },
    set_defence (state, defence) {
      state.defence = defence
    },
    set_topc (state, topc) {
      state.topc = topc
    },
    set_door_open (state, doorOpen) {
      state.doorOpen = doorOpen
    },
    set_door_suc (state, doorSuc) {
      state.doorSuc = doorSuc
    },
    set_door_err (state, doorErr) {
      state.doorErr = doorErr
    },
    set_alarm_handle (state, alarmHandle) {
      state.alarmHandle = alarmHandle
    },
    set_alarm_id (state, alarmid) {
      state.alarmid = alarmid
    },
    set_child_obj (state, childObj) {
      state.childObj = childObj
    },
    set_scene_room (state, obj) {
      state.sceneRoom = obj
    },
    set_app_id (state, appId) {
      state.appId = appId
    },
    set_sub_device (state, sub) {
      state.subDevice = sub
    },
    set_family_obj (state, obj) {
      state.familyObj = obj
    },
    set_room_obj (state, obj) {
      state.roomObj = obj
    }
  },
  getters: {
    get_openid (state) {
      return state.OpenID
    },
    get_token (state) {
      return state.token
    },
    get_user (state) {
      return state.user
    },
    get_door (state) {
      return state.door
    },
    get_topc (state) {
      return state.topc
    },
    get_nooff (state) {
      return state.nooff
    },
    get_ding (state) {
      return state.ding
    },
    get_door_open (state) {
      return state.doorOpen
    },
    get_door_suc (state) {
      return state.doorSuc
    },
    get_door_err (state) {
      return state.doorErr
    },
    get_alarm_handle (state) {
      return state.alarmHandle
    },
    get_alarm_id (state) {
      return state.alarmid
    },
    get_child_obj (state) {
      return state.childObj
    },
    get_scene_room (state) {
      return state.sceneRoom
    },
    get_app_id (state) {
      return state.appId
    },
    get_sub_device (state) {
      return state.subDevice
    },
    get_family_obj (state) {
      return state.familyObj
    },
    get_room_obj (state) {
      return state.roomObj
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js